import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import Routes from "./routes";
import { withTranslation, Trans } from "react-i18next";

class Technician extends Component {
  render() {
    const { ssoId } = this.props;
    return (
      <Wrapper>
        <BreadcrumbsItem
          glyph
          to={"/timetracking/" + ssoId + "/technician/hourslogin"}
        >
          <Trans>technician</Trans>
        </BreadcrumbsItem>
        <Routes {...this.props} />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const mapStateToProps = ({ auth, fetchTimesheetSecurity }) => {
  return {
    ssoId: auth.ssoId,
    security: fetchTimesheetSecurity.securityList
  };
};

export default withRouter(
  connect(mapStateToProps)(withTranslation()(Technician))
);
